import { IDataGridColumn, IDataGridConfig } from '@app/shared/interfaces/data-grid-column';
import * as moment from 'moment';
import { urlTemplate } from '../../../../../shared/constants/datagrid-url-template';
import { TranslateService } from '@ngx-translate/core';

export const getTransactionsDataGridConfig = (translateService?: TranslateService): IDataGridConfig => {
  // Columns
  const transactionsDataGridColumns: IDataGridColumn[] = [
    {
      dataField: 'createdDate',
      caption: 'string.date',
      allowFiltering: true,
      allowSorting: true,
      dataType: 'datetime',
      calculateCellValue: ({ createdDate }) => moment(createdDate).format('MM/DD/YY hh:mm a'),
      width: 162,
    },
    {
      dataField: 'transType',
      caption: 'string.type',
      allowFiltering: true,
      allowSorting: true,
      dataType: 'string',
      width: 100,
      headerCellTemplate: 'typeHeader',
    },
    {
      dataField: 'quantity',
      caption: 'string.quantity',
      allowFiltering: false,
      allowSorting: true,
      allowSearch: true,
      dataType: 'number',
      width: 112,
      headerFilter: { allowSearch: false },
    },
    {
      dataField: 'crib.name',
      caption: 'crib.crib',
      allowFiltering: true,
      allowSorting: true,
      dataType: 'string',
      width: 150,
      encodeHtml: false,
      calculateCellValue: urlTemplate,
      hideFromColumnChooser: true,
    },
    {
      dataField: 'bin.name',
      caption: 'bin.bin',
      allowFiltering: true,
      allowSorting: true,
      dataType: 'string',
      width: 150,
      encodeHtml: false,
      calculateCellValue: urlTemplate,
    },
    {
      dataField: 'item.sku',
      caption: 'string.sku',
      allowFiltering: true,
      allowSorting: true,
      dataType: 'string',
      width: 180,
      encodeHtml: false,
      calculateCellValue: urlTemplate,
    },
    {
      dataField: 'item.name',
      caption: 'string.item-name',
      allowFiltering: true,
      allowSorting: true,
      dataType: 'string',
      width: 180,
      encodeHtml: false,
      calculateCellValue: urlTemplate,
    },
    {
      dataField: 'item.itemAliasSku',
      caption: 'transactions.alias-item-sku',
      allowFiltering: true,
      allowSorting: true,
      dataType: 'string',
      width: 180,
      visible: false,
      customerOnly: true,
    },
    {
      dataField: 'item.itemAliasName',
      caption: 'transactions.alias-item-name',
      allowFiltering: true,
      allowSorting: true,
      dataType: 'string',
      width: 180,
      visible: false,
      customerOnly: true,
    },
    {
      dataField: 'user.profileId',
      caption: 'users.user-id',
      allowFiltering: true,
      allowSorting: true,
      dataType: 'string',
      width: 180,
    },
    {
      dataField: 'crib.deviceName',
      caption: 'string.device',
      allowFiltering: true,
      allowSorting: true,
      dataType: 'string',
      width: 180,
    },
    {
      dataField: 'bin.hardwareAddress',
      caption: 'bin.hardware-address',
      allowFiltering: true,
      allowSorting: true,
      dataType: 'string',
      width: 180,
    },
    {
      dataField: 'bin.newQuantity',
      caption: 'string.new-quantity',
      allowFiltering: false,
      allowSorting: true,
      allowSearch: true,
      dataType: 'number',
      width: 160,
      headerFilter: { allowSearch: false },
    },
    {
      dataField: 'relatedValue',
      caption: 'string.related-value',
      allowFiltering: true,
      allowSorting: true,
      dataType: 'string',
      width: 160,
    },
    {
      dataField: 'approvedBy.profileId',
      caption: 'string.approvedBy',
      allowFiltering: true,
      allowSorting: true,
      dataType: 'string',
      width: 180,
    },
  ];

  const transactionsDataGridConfig: IDataGridConfig = {
    dataGridColumns: transactionsDataGridColumns,
    defaultSort: 'createdDate',
    enableColumnChooser: true,
    isDescSort: true,
    dataSourceKey: 'TransactionLogs',
    sourceModule: 'Transactions',
    allowExport: true,
    showRowSearch: true,
    showToolbar: true,
  };

  return transactionsDataGridConfig;
};
